module.exports = __webpack_public_path__ + "media/Video 32.7f2b96cf.mp4";